import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { TravelNerdLogo } from '@cc-shopping/ui/primitives/Icons/TravelNerdLogo';
import clsx from 'clsx';
import { AnalyticsWrapper } from './Analytics/AnalyticsWrapper';
import { TravelNerdImage } from './Images/TravelNerdImage';
import { SignUpForm } from './SignUpForm';
import type { TravelNerdBannerAnalytics } from './types';
type TravelNerdBannerProps = {
  noImage?: boolean;
  analytics?: TravelNerdBannerAnalytics;
};
export const TravelNerdBanner = t0 => {
  const $ = _c(22);
  const {
    noImage,
    analytics
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("justify-start", "items-start", "gap-16", "flex", "self-stretch");
    t2 = clsx("bg-yellow-lighter-2", "flex", "flex-col", "md:flex-row", "items-center", "w-full", "gap-8", "mx-auto");
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== noImage) {
    t3 = !noImage && <div className={clsx("hidden", "md:flex", "self-end")}><TravelNerdImage /></div>;
    $[2] = noImage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = clsx("px-4", "py-6", "gap-4", "flex", "flex-col");
    t5 = <div className={clsx("w-[246px]", "h-[50px]", "relative")}><TravelNerdLogo /></div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== noImage) {
    t6 = clsx("font-medium", "text-medium", {
      "md:text-[1.25rem]": !noImage
    }, {
      "md:leading-8": !noImage
    }, "my-0");
    $[6] = noImage;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <p className={t6}>Vacation more, spend less. Subscribe to our free newsletter for inspiration, tips, and money-saving strategies – delivered straight to your inbox.</p>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={clsx("min-h-[130px]", "md:min-h-[95px]")}><SignUpForm /></div>;
    t9 = clsx("text-xsmall", "my-0");
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a href={`${env.NEXT_PUBLIC_NW_URL}p/terms-of-use`} target="_blank" className={clsx("text-blue-default", "underline")} aria-label="Terms of Use" rel="noopener">Terms of Use</a>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className={t9}>By signing up, you will receive newsletters and promotional content and agree to our{" "}{t10}{" "}and acknowledge the data practices in our{" "}<a href={`${env.NEXT_PUBLIC_NW_URL}p/privacy-policy`} target="_blank" className={clsx("text-blue-default", "underline")} aria-label="Privacy Policy" rel="noopener">Privacy Policy</a>. You may unsubscribe at any time.</p>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t7) {
    t12 = <div className={t4}>{t5}{t7}{t8}{t11}</div>;
    $[14] = t7;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t3) {
    t13 = <div className={t1}><div className={t2}>{t3}{t12}</div></div>;
    $[16] = t12;
    $[17] = t3;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== analytics || $[20] !== t13) {
    t14 = <AnalyticsWrapper analytics={analytics}>{t13}</AnalyticsWrapper>;
    $[19] = analytics;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
};